import React, { useState, useEffect } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import axios from "axios";

import Back from "../../../Back";

import { useSelector } from "react-redux";

import encodeJWT from "./jwt.encode";

const PlayModuleBtn = () => {
  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  const origin = window.location.origin;

  const location = useLocation();

  let { tid } = location.state;

  const [gameData, setGameData] = useState({});

  const { id } = useParams();

  const [play, setPlay] = useState(false);
  const [encodeToken,setEncodeToken]=useState("")
  const configData = useSelector((state) => state.configSlice);

  const playmoduleIframe = () => {
    setPlay(true);
  };

  const navigate = useNavigate();

  const fetchGamesData = async () => {
    const reponse = await axios.get(`${configData?.config?.apiBaseUrl}/api/fetchGameData/${id}`, {
      headers: {
        Authorization: `Bearer ${userData.token}`,
      },
    });
    setGameData(reponse.data.data);
  };

  useEffect(() => {
    fetchGamesData();
    setEncodeToken(encodeJWT());
    window.addEventListener("message", (e) => {
      try {
        if (e.data == "GAME_ENDED") {
          navigate(`/traits/insights/${tid}/${uuid}`);
        }
      } catch {
        console.log("Error in playmoduleIframe");
      }
    });
  }, []);

  return (
    <>
      <div className="container-fluid p-3">
        <div className="row">
          <div className="col-md-7">
            <h6>
              <Back /> {gameData?.name}
            </h6>
          </div>
          <div className="col-md-5 text-end">
            <button
              className="btn btn-sm btn-light text-danger px-3 mb-2"
              onClick={() => navigate(`/traits/insights/${id}/${uuid}`)}
            >
              Insights
            </button>
          </div>
        </div>

        {play ? (
          <>
            <div className="playmodule">
              <div className="  w-100 position-relative z-index-99">
                {
                  <iframe
                    id="myIframe"
                    className="playmodule"
                    src={`${gameData.gamelink}?token=${encodeToken}`}
                    allowFullScreen
                  />
                }
              </div>
            </div>
          </>
        ) : (
          <>
            {" "}
            <div className="playmodule" style={{ background: `url(${gameData?.icon}) center/cover` }}>
              <div className="row  w-100 position-relative z-index-99">
                <div className="col-md-10">
                  <div className="playmodulecont">
                    <h3 className="mb-0 text-white">{gameData?.name}</h3>
                    <p className="py-3 mb-0 font-xs">{gameData?.instructions?.welcome}</p>
                    <ul className="pointsxdf">
                      {gameData?.instructions?.points &&
                        gameData?.instructions?.points.map((point, index) => <li key={index}>{point}</li>)}
                    </ul>
                    <p className="mb-0 font-xs">{gameData?.instructions?.takeAMoment}</p>
                    <p className="mb-0 font-xs">{gameData?.instructions?.aim}</p>
                    <p className="mb-0 font-xs">{gameData?.instructions?.goodLuck}</p>

                    <button onClick={playmoduleIframe} className="btn btn-white px-5 text-warning border-warning mt-4">
                      Play
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PlayModuleBtn;
